import { isValid, formatISO, parseISO } from 'date-fns';
import { tz } from '@date-fns/tz';

/** @internal */
export function _getSystemTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

/**
 * Formats Date objects (or now) into ISO strings with the system's local time zone.
 *
 * Ensures correct handling of time zones when **SENDING** data via APIs.
 */
export function toLocalISO(date: Date = new Date()): string {
    if (!isValid(date)) {
        throw new Error('Invalid date provided to toLocalISO');
    }

    const systemTZ = _getSystemTimeZone();
    return formatISO(date, { in: tz(systemTZ) });
}

/**
 * Parses ISO strings from any timezone into Date objects with the system's local time zone.
 *
 * Ensures correct handling of time zones when **RECEIVING** data via APIs.
 */
export function toLocalDate(date: string): Date {
    if (!date || typeof date !== 'string') {
        console.error('Invalid date string provided to toLocalDate', date);
        throw new Error('Invalid date string provided to toLocalDate');
    }

    const systemTZ = _getSystemTimeZone();
    const parsed = parseISO(date, { in: tz(systemTZ) });
    if (!isValid(parsed)) {
        console.error('Unable to parse date string', date);
        throw new Error(`Unable to parse date string: ${date}`);
    }
    return parsed;
}
